import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "../../../components/ui";

export const formatMoney = (amount, currency = "USD") => {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: ["XOF", "XAF"].includes(currency) ? 0 : 2,
    }).format(amount);
  } catch (error) {
    return `${amount} ${currency}`;
  }
};

export const formatWhen = (date) =>
  date
    ? new Date(date).toLocaleString([], { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "—";

/** Chart colors of the payment types (brand blue, champagne). */
export const TYPE_COLORS = {
  subscription: "#1176BC",
  subscription_renewal: "#6FB3E0",
  donation: "#CDAE6E",
  exclusive: "#8b7cf6",
  other: "#5b6475",
};

export const TYPES = {
  donation: { label: "Donation", color: "violet", icon: "ri-heart-line" },
  subscription: { label: "Subscription", color: "blue", icon: "ri-vip-crown-line" },
  subscription_renewal: { label: "Renewal", color: "blue", icon: "ri-repeat-line" },
  exclusive: { label: "Exclusive content", color: "amber", icon: "ri-film-line" },
};

export const TypeLabel = ({ payment }) => {
  const { t } = useTranslation();
  const type = TYPES[payment.type] || { label: "Payment", color: "slate", icon: "ri-money-dollar-circle-line" };
  return (
    <Badge color={type.color}>
      <i className={type.icon} aria-hidden="true"></i>
      {t(type.label)}
      {payment.plan ? ` · ${t(payment.plan === "annual" ? "Annual" : "Monthly")}` : ""}
    </Badge>
  );
};

const STATUSES = {
  SUCCESS: { label: "Succeeded", color: "green" },
  FAILED: { label: "Failed", color: "red" },
  PENDING: { label: "Pending", color: "amber" },
};

export const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const known = STATUSES[status] || STATUSES.PENDING;
  return (
    <Badge color={known.color} dot>
      {t(known.label)}
    </Badge>
  );
};

const METHODS = {
  stripe: "Card",
  apple_pay: "Apple Pay",
  google_pay: "Google Pay",
  cinetpay: "Mobile Money · CinetPay",
  paystack: "Mobile Money · Paystack",
  pawapay: "Mobile Money · pawaPay",
};

export const MethodLabel = ({ payment }) => {
  const { t } = useTranslation();
  const extra = payment.card
    ? ` ${payment.card.brand ? payment.card.brand.toUpperCase() : ""} •••• ${payment.card.last4}`
    : payment.operator
    ? ` (${payment.operator})`
    : "";
  return (
    <span>
      {t(METHODS[payment.method] || payment.method)}
      {extra}
    </span>
  );
};
